var poll_default = {
  "fontElementMap": "iWg2N",
  "container": "TIdfo",
  "fullscreen": "B7LDs",
  "background_overlay": "cZWnT",
  "with_image": "q-0Aa",
  "options": "_9lIr2",
  "webview": "TtgT0",
  "grid": "DuIqu",
  "option": "WXy2m",
  "cta_button": "AYZBo",
  "add_option": "_-54qP",
  "see_more": "f4EEY",
  "list": "UATag",
  "column": "RQIdX",
  "additional_note": "_7A-9k",
  "spinner": "rkLWG",
  "spin": "_8IhGx",
  "shown": "_8B28k",
  "error": "NrqTw"
};
export {
  poll_default as default
};
//# sourceMappingURL=poll-scss.js.map
